import req from "@/api/config/config";
import { Message } from "element-ui";

export default {
    // 统计供应商开标数据
    countSupplierOpenBidInfo(params) {
        return req.service({
            url: `${req.systemIp}/website/supplier/countSupplierOpenBidInfo`,
            method: "get",
            params,
        });
    },

    // 获取最新公告详情
    queryNewBulletinDetail(params) {
        return req.service({
            url: `${req.systemIp}/website/projectBulletin/queryNewBulletinDetail`,
            method: "get",
            params,
        });
    },

    // 根据项目id查询报名信息
    querySignUpInfo(params) {
        return req.service({
            url: `${req.systemIp}/website/projectBulletin/querySignUpInfo`,
            method: "get",
            params,
        });
    },
    // 创建资料预审
    datPreExamination(data) {
        return req.service({
            url: `${req.systemIp}/website/projectSign/datPreExamination`,
            method: "post",
            data,
        });
    },
    // 在线报名
    signUp(data) {
        return req.service({
            url: `${req.systemIp}/website/projectSign/signUp`,
            method: "post",
            data,
        });
    },

    // 查询结果公告列表
    queryResultBulletinList(params) {
        return req.service({
            url: `${req.systemIp}/website/projectResultBulletin/queryResultBulletinList`,
            method: "get",
            params,
        });
    },
    // 查询以前的结果公告列表
    queryOriginalResultBulletinList(params) {
        return req.service({
            url: `${req.systemIp}/website/projectResultBulletin/queryOriginalResultBulletinList`,
            method: "get",
            params,
        });
    },

    // 支付报名付费
    paySignUpFee(params) {
        return req.service({
            url: `${req.systemIp}/website/projectSign/paySignUpFee`,
            method: "put",
            params,
        });
    },

    // 供应商查询项目详情
    queryProjectDetail(params) {
        return req.service({
            url: `${req.systemIp}/website/projectSign/queryProjectDetail`,
            method: "get",
            params,
        });
    },

    ///////////////////////////

    //查询当前域名的公司信息
    orgInfo(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/org/info`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "pc/ext",
            },
            params,
        });
    },

    // 获取公告列表
    queryBulletinList(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/project/notice/page`,
            method: "get",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "BIDDING-SOURCE": "pc/ext",
            },
            params,
        });
    },
    // 获取询价竞价公告列表
    queryPriceList(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/inquiry/notice/page`,
            method: "get",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "BIDDING-SOURCE": "/pc/ext",
            },
            params: { ...params, supplyType: JSON.parse(localStorage.getItem("userInfo") || "{}").supplyType || '' },
        });
    },


    // 获取询价竞价公告列表
    resultPage(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/inquiry/result/page`,
            method: "get",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "BIDDING-SOURCE": "/pc/ext",
            },
            params,
        });
    },

    // 获取询价竞价公告列表
    resultInfo(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/inquiry/result/info/${params}`,
            method: "get",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "BIDDING-SOURCE": "/pc/ext",
            },
            // params,
        });
    },
    // 获取结果公告详情
    queryBulletinDetail(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/project/notice/info`,
            method: "get",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "BIDDING-SOURCE": "pc/ext",
            },
            params,
        });
    },

    // 获取项目详情
    projectDetail(params) {
        // let userInfo = localStorage.getItem("userInfo");
        // if (!userInfo) {
        //   Message.warning("请登录");
        //   location.href = "#/choice";
        //   return;
        // }

        return req.service({
            url: `${req.systemIp}/pc/project/info`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            params,
        });
    },
    // 获取询价竞价公告项目详情
    inqueryDetail(params) {
        // let userInfo = localStorage.getItem("userInfo");
        // if (!userInfo) {
        //   Message.warning("请登录");
        //   location.href = "#/choice";
        //   return;
        // }

        return req.service({
            url: `${req.systemIp}/pc/inquiry/notice/info/${params.id}`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            // params,
        });
    },

    // 获取询价竞价公告项目详情
    inqueryDetailNoLogin(params) {

        return req.service({
            url: `${req.systemIp}/pc/ext/inquiry/notice/info/${params}`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "PC",
                // Authorization:
                //   "Bearer " +
                //   `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            // params,
        });
    },
    //项目报名
    enroll(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/enroll`,
            method: "post",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            data,
        });
    },

    //项目标书购买
    orderBuy(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/bidding/file/order`,
            method: "post",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            data,
        });
    },

    // 获取项目招标文件信息
    fileInfo(params) {
        return req.service({
            url: `${req.systemIp}/pc/project/file/info`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            params,
        });
    },
    // 询价竞价报名信息
    inquiryOrderInfo(data) {
        return req.service({
            url: `${req.systemIp}/pc/inquiry/notice/enroll`,
            method: "post",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            data,
        });
    },
    // 询价竞价报价金额和询价文件
    inquiryPriceAndFilmInfo(data) {
        return req.service({
            url: `${req.systemIp}/pc/inquiry/notice/addInfo`,
            method: "post",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            data,
        });
    },
    // 分页我的项目信息（供应商）
    queryMyProjectSignList(params) {
        return req.service({
            url: `${req.systemIp}/pc/project/page`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            params,
        });
    },

    // 分页查询参与的询价竞价
    queryMyProjectSignListV2(params) {
        return req.service({
            url: `${req.systemIp}/pc/inquiry/enroll/page`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
            params,
        });
    },
    // 查询结果公告列表
    queryCompanyProfile(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/org/description`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                // Authorization:
                //   "Bearer " +
                //   `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },

    // 获取banner列表
    queryBannerListByPosition(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/banner/list`,
            method: "get",
            headers: {
                "BIDDING-SOURCE": "pc/ext",
            },
            params,
        });
    },

    // 上传招标文件
    uploadFile(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/bid/file/upload`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },




    // 查询套餐列表
    suiteList(params) {
        return req.service({
            url: `${req.systemIp}/pc/member/suite/list`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                // Authorization:
                //   "Bearer " +
                //   `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },


    //查询项目专家聊天列表
    specialist(params) {
        return req.service({
            url: `${req.systemIp}/pc/chat/specialist/list`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },


    //项目专家聊天记录
    chatPage(params) {
        return req.service({
            url: `${req.systemIp}/pc/chat/page`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },


    // 上传招标文件
    chatSave(data) {
        return req.service({
            url: `${req.systemIp}/pc/chat/save`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },

    checkCa(params) {
        return req.service({
            url: `${req.systemIp}/pc/supplier/check/ca`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },


    // 保存再次报价
    secondPrice(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/secondPrice`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },

    //修改报价
    updateQuote(data) {
        return req.service({
            url: `${req.systemIp}/pc/inquiry/updateQuote`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },
    //报价列表
    quotedList(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/quoted`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },

    // suiteList(params) {
    //   return req.service({
    //     url: `${req.systemIp}/pc/member/suite/list`,
    //     method: "get",
    //     params,
    //     headers: {
    //       "BIDDING-SOURCE": "PC",
    //       // Authorization:
    //       //   "Bearer " +
    //       //   `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
    //     },
    //   });
    // },
    //会员购买支付
    activeMember(data) {
        return req.service({
            url: `${req.systemIp}/pc/member/activeMember?suiteId=${data.suiteId}`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },
    //订单状态轮询
    pollingOrder(data) {
        return req.service({
            url: `${req.systemIp}/pc/member/polling/order?orderNo=${data.orderNo}`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },



    //查询项目开标记录信息
    bidRecord(params) {
        return req.service({
            url: `${req.systemIp}/pc/project/bidRecord`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },



    //会员购买支付
    contractSave(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/contract/save`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },
    //查询项目开标记录信息
    notice(params) {
        return req.service({
            url: `${req.systemIp}/pc/project/bidder/notice`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },


    //订单状态轮询
    receipt(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/enroll/receipt`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },


    //保证金设置详情
    bondInfo(data) {
        return req.service({
            url: `${req.systemIp}/pc/project/bond/file/info/${data}`,
            method: "get",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },

    //拒绝响应
    reject(data) {
        return req.service({
            url: `${req.systemIp}/pc/inquiry/reject`,
            method: "post",
            data,
            headers: {
                "BIDDING-SOURCE": "PC",
                Authorization:
                    "Bearer " +
                    `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            },
        });
    },




    //情况文件查询
    situationPage(params) {
        return req.service({
            url: `${req.systemIp}/pc/ext/inquiry/situation/page`,
            method: "get",
            params,
            headers: {
                "BIDDING-SOURCE": "/pc/ext",
            },
        });
    },
};
